import { Box, Divider, Heading, HStack, useColorMode } from '@chakra-ui/react';
import React, { ReactNode } from 'react';

type StickyHeaderSectionProps = {
  labelText?: string;
  children: ReactNode;
  labelRightComponent?: ReactNode;
};
export const StickyHeaderSection = ({
  labelText,
  children,
  labelRightComponent,
}: StickyHeaderSectionProps) => {
  const { colorMode } = useColorMode();
  return (
    <>
      {/* the element that has position sticky needs to be the direct child of the sticky container to attach itself correctly */}
      {labelText && (
        <Box
          height="fit-content"
          position="sticky"
          top="0"
          backgroundColor={colorMode === 'light' ? 'white' : 'gray.950'}
        >
          <HStack>
            <Heading
              fontWeight="bold"
              fontSize="28px"
              mr="2"
              textTransform="capitalize"
            >
              {labelText}
            </Heading>
            {labelRightComponent}
          </HStack>
          <Divider mt="5px" mb="35px" />
        </Box>
      )}
      <Box mb="70px">{children}</Box>
    </>
  );
};
